// Store.js
import React, { createContext, useContext, useState } from "react";
import axios from "axios";

const TodoContext = createContext();

export const TodoProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState("");
  const [editId, setEditId] = useState(null);
  const [editText, setEditText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchTasks = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/my-to-do`)
      .then((res) => {
        setTasks(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching tasks:", err);
        setError("Failed to load tasks");
        setLoading(false);
      });
  };

  const handleAddTask = () => {
    if (newTask.trim() === "") {
      alert("Task cannot be empty!");
      return;
    }
    const newTaskObj = { text: newTask, completed: false };
    axios
      .post(`${BASE_URL}/my-to-do`, newTaskObj)
      .then((res) => {
        setTasks([...tasks, res.data]);
        setNewTask("");
      })
      .catch((err) => console.error("Error adding task:", err));
  };

  const handleDeleteTask = (id) => {
    axios
      .delete(`${BASE_URL}/my-to-do/${id}`)
      .then(() => setTasks(tasks.filter((task) => task.id !== id)))
      .catch((err) => console.error("Error deleting task:", err));
  };

  const handleToggleTask = (id) => {
    const task = tasks.find((t) => t.id === id);
    const updatedTask = { ...task, completed: !task.completed };
    axios
      .put(`${BASE_URL}/my-to-do/${id}`, updatedTask)
      .then(() => {
        setTasks(tasks.map((t) => (t.id === id ? updatedTask : t)));
      })
      .catch((err) => console.error("Error toggling task:", err));
  };

  const handleEditTask = (id, text) => {
    setEditId(id);
    setEditText(text);
  };

  const handleSaveEdit = (id) => {
    if (editText.trim() === "") {
      alert("Task cannot be empty!");
      return;
    }
    const updatedTask = { ...tasks.find((t) => t.id === id), text: editText };
    axios
      .put(`${BASE_URL}/my-to-do/${id}`, updatedTask)
      .then(() => {
        setTasks(tasks.map((t) => (t.id === id ? updatedTask : t)));
        setEditId(null);
        setEditText("");
      })
      .catch((err) => console.error("Error saving edit:", err));
  };

  const handleCancelEdit = () => {
    setEditId(null);
    setEditText("");
  };

  return (
    <TodoContext.Provider
      value={{
        tasks,
        newTask,
        editId,
        editText,
        loading,
        error,
        fetchTasks,
        setNewTask,
        handleAddTask,
        handleDeleteTask,
        handleToggleTask,
        handleEditTask,
        handleSaveEdit,
        handleCancelEdit,
      }}
    >
      {children}
    </TodoContext.Provider>
  );
};

// ✅ Custom hook to consume context
export const useTodo = () => useContext(TodoContext);
